<template>
    <page title="competitionApprovalDetailView" :textHeight="(WindowSize.y - 276) + 'px'">
        <template #pageContainer>
				<v-row>
					<v-col>
						<v-textarea
							:label="$t(`text.headerReason`)"
							v-model="reason"
						></v-textarea>
					</v-col>
				</v-row>
            <spinner :loading="loading"></spinner>
        </template>
		<template #pageActions>
			<v-row>
				<v-col>
					<v-btn
						v-if="!editStateMode"
						class="mr-4"
						@click="updateApprovalState">
						{{ $t(`text.cancel`) }}
					</v-btn>
					<v-btn
						v-if="editStateMode"
						class="mr-4"
						@click="updateApprovalState(1)">
						{{ $t(`text.approve`) }}
					</v-btn>
					<v-btn
						v-if="editStateMode"
						class="mr-4"
						@click="updateApprovalState(2)">
						{{ $t(`text.rejectButton`) }}
					</v-btn>
					<v-btn
						class="mr-4"
						@click="back">
						{{ $t(`text.backButton`) }}
					</v-btn>
				</v-col>
			</v-row>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import compApprovalActions from '../store/actions/compApproval';
import namespace from '../store/namespace';

import Page from '../general/Page.vue';
import Spinner from '../general/Spinner.vue';
import modelState from '../mixins/modelState';

export default {
	name: 'CompetitionApprovalEditState',
	mixins: [modelState],
	components: {
		Page,
		Spinner,
	},
	data() {
		return {
			loading: false,
			reason: '',
		};
	},
	async mounted() {
		this.loading = true;
		if (this.CompApprLinks.length === undefined || this.CompApprLinks.length === 0) {
			await this.GET_COMP_APPROVAL_LINKS();
		}
		const link = this.CompApprLinks.find(x => x.rel === 'get_by_id');
		if (link) {
			await this.GET_COMP_BY_ID({ link, cGuid: this.cGuid });

			if (this.editStateMode) {
				const approval = this.Competition.approvals.find(x => x.organizationId === this.Organization);
				if (approval) this.reason = approval.reason;
			} else {
				this.reason = this.Competition.cancelationReason;
			}
			const approval = this.Competition.approvals.find(x => x.organizationId === this.Organization);
			if (approval) this.reason = approval.reason;
		}
		this.loading = false;
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.COMPETITIONAPPROVAL, ['CompApprLinks', 'Competition']),
		...mapGetters(namespace.ORGANIZATION, ['Organization']),
		cGuid() {
			return this.$route.params.cGuid || null;
		},
		editStateMode() {
			return this.$route.name === 'CompetitionApprovalEditState';
		},
	},
	methods: {
		...mapActions(namespace.COMPETITIONAPPROVAL, [
			compApprovalActions.GET_COMP_APPROVAL_LINKS,
			compApprovalActions.GET_COMP_BY_ID,
			compApprovalActions.SEND_APPROVAL_UPDATE,
			compApprovalActions.SEND_APPROVAL_CANCELLATION,
		]),
		async updateApprovalState(state) {
			this.loading = true;

			let link = null;
			if (this.editStateMode) {
				link = this.CompApprLinks.find(x => x.rel === 'approve_competition');
			} else {
				link = this.CompApprLinks.find(x => x.rel === 'cancel_comp');
			}

			if (link) {
				try {
					this.modelState = {};

					if (this.editStateMode) {
						await this.SEND_APPROVAL_UPDATE({
							link, cGuid: this.cGuid, oGuid: this.Organization, update: { reason: this.reason, approvalState: state },
						});
					} else {
						await this.SEND_APPROVAL_CANCELLATION({
							link, cGuid: this.cGuid, reason: this.reason,
						});
					}
				} catch (e) {
					console.log(e);
					if (e.response.status === 422) {
						this.modelState = e.response.data;
						if (this.modelError()) {
							throw new Error(this.modelError());
						}
					}

					throw e;
				} finally {
					this.loading = false;
				}
			}
			this.loading = false;
			this.back();
		},
		back() {
			this.$router.go(-1);
		},
	},
};
</script>
